import { Injectable } from '@angular/core';
import { ConfigModel } from '../../config/config.model';
import { TranslateService } from '@ngx-translate/core';
import { UrlParamsService } from './urlParams.service';
import { Base64 } from 'js-base64';
import { Globals } from '../../../app.globals';

@Injectable()
export class LogoutService {
    constructor(
        private translate: TranslateService,
        private urlParamsService: UrlParamsService,
    ) {
    }

    getLogoutUrl(configModel: ConfigModel, state?: string): string {
        let isGeorge4B;
        try {
            isGeorge4B = state ? JSON.parse(Base64.decode(state)).srcClientId === Globals.georgeBusinessClientId : null;
        } catch (e) {
            isGeorge4B = false;
        }
        if (this.urlParamsService.isGeorge4B() || isGeorge4B) {
            return this.translate.currentLang === 'en' ? configModel.mciLogoutRedirectURIG4bEn : configModel.mciLogoutRedirectURIG4b;
        } else {
            return this.translate.currentLang === 'en' ? configModel.mciLogoutRedirectURIEn : configModel.mciLogoutRedirectURI;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/services/logout.service.ts